











import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import UrlMixin from '@/mixins/url';
import ImageMixin from '@/mixins/image';

import FooterNav from '@/components/Molecules/Nav/FooterNav.vue';
import FooterImageNav from '@/components/Molecules/Nav/FooterImageNav.vue';

@Component({
  components: {
    FooterNav,
    FooterImageNav,
  },
})
export default class FooterForBottomNav extends mixins(UrlMixin, ImageMixin) {
  @Prop({ default: 'bottom' }) location!: 'bottom' | 'right';
  get copyright() {
    const date: Date = new Date();
    return 'Copyright(C)BIGLOBE Inc. 1996-' + date.getFullYear();
  }
}
